import { render } from "./bmTopicInfo.vue?vue&type=template&id=43b80e36&scoped=true"
import script from "./bmTopicInfo.vue?vue&type=script&lang=js"
export * from "./bmTopicInfo.vue?vue&type=script&lang=js"

import "./bmTopicInfo.vue?vue&type=style&index=0&id=43b80e36&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b80e36"]])

export default __exports__